/*
This is the left side navigation thats used in /org/:orgName/settings
It should be used for the entire platform
We're maintaining two until we migrate everything else to this one
*/
import { Box, Typography } from '@mui/material';

import { useStyles } from './styles';
import { isNavigationItem, NavigationGroups } from './interfaces';
import { MenuItem } from './menu-item';

function LeftSideNavigationMenu({ items }: { items: NavigationGroups }) {
  const { cx, classes } = useStyles();
  if (!items.length) return null;

  return (
    <Box className={classes.sideMenuContainer}>
      {items.map((item) => {
        return isNavigationItem(item) ? (
          <MenuItem key={item.id} item={item} disabled={item.disabled} />
        ) : (
          <Box key={item.id} sx={{ display: 'flex', gap: 1, flexDirection: 'column' }}>
            <Box className={cx(classes.groupHeaderContainer)}>
              <Typography className={cx(classes.navGroupHeader)}>{item.title}</Typography>
            </Box>
            <Box sx={{ display: 'flex', gap: 1.5, flexDirection: 'column' }}>
              {item.items.map((item) => (
                <MenuItem item={item} key={item.id} />
              ))}
            </Box>
          </Box>
        );
      })}
    </Box>
  );
}

export { LeftSideNavigationMenu };
